/** Matches report line charts (`line-chart.util.ts` → `pointHoverRadius: 10`). */
export const REPORT_LINE_POINT_HOVER_RADIUS = 10;
/** Smaller hover ring for dashed secondary lines (benchmark median, org avg). */
export const REPORT_LINE_SECONDARY_POINT_HOVER_RADIUS = 6;
export const REPORT_LINE_POINT_HIT_RADIUS = 15;
export const REPORT_LINE_POINT_BORDER_WIDTH = 2;

type HoverPointStyle = {
  pointRadius: number | number[];
  pointHoverRadius: number | number[];
  pointHitRadius?: number | number[];
  pointBackgroundColor: string | string[];
  pointHoverBackgroundColor: string | string[];
  pointBorderColor: string | string[];
  pointHoverBorderColor: string | string[];
  pointBorderWidth: number | number[];
  pointHoverBorderWidth: number | number[];
};

function hoverPointFill(color: string): string {
  return `${color}25`;
}

/** Small solid dot — percentile band edges on the time-series chart (hover only). */
export function smallSolidHoverPoint(color: string): HoverPointStyle {
  return {
    pointRadius: 0,
    pointHoverRadius: 3,
    pointHitRadius: REPORT_LINE_POINT_HIT_RADIUS,
    pointBackgroundColor: color,
    pointHoverBackgroundColor: color,
    pointBorderColor: 'transparent',
    pointHoverBorderColor: 'transparent',
    pointBorderWidth: 0,
    pointHoverBorderWidth: 0,
  };
}

/** Hollow ring on hover — benchmark / secondary lines; same size as report line charts. */
export function ringHoverPoint(
  color: string,
  radius = REPORT_LINE_POINT_HOVER_RADIUS,
  borderWidth = REPORT_LINE_POINT_BORDER_WIDTH,
): HoverPointStyle {
  return {
    pointRadius: 0,
    pointHoverRadius: radius,
    pointHitRadius: REPORT_LINE_POINT_HIT_RADIUS,
    pointBackgroundColor: 'transparent',
    pointHoverBackgroundColor: hoverPointFill(color),
    pointBorderColor: 'transparent',
    pointHoverBorderColor: color,
    pointBorderWidth: 0,
    pointHoverBorderWidth: borderWidth,
  };
}

/** Primary org/segment line — no dots at rest, report-sized hollow ring on hover. */
export function orgLinePoints(color: string, scores: Array<number | null>): HoverPointStyle {
  const hasScore = (score: number | null) => score != null;

  return {
    pointRadius: scores.map(() => 0),
    pointHoverRadius: scores.map((score) => (hasScore(score) ? REPORT_LINE_POINT_HOVER_RADIUS : 0)),
    pointHitRadius: REPORT_LINE_POINT_HIT_RADIUS,
    pointBackgroundColor: 'transparent',
    pointHoverBackgroundColor: hoverPointFill(color),
    pointBorderColor: scores.map(() => 'transparent'),
    pointHoverBorderColor: color,
    pointBorderWidth: scores.map(() => 0),
    pointHoverBorderWidth: REPORT_LINE_POINT_BORDER_WIDTH,
  };
}
